/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offers_Pack_SessionsInputs */

const en_offers_pack_sessions = /** @type {(inputs: Offers_Pack_SessionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sessions`)
};

const pl_offers_pack_sessions = /** @type {(inputs: Offers_Pack_SessionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wejść`)
};

/**
* | output |
* | --- |
* | "{count} sessions" |
*
* @param {Offers_Pack_SessionsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_pack_sessions = /** @type {((inputs: Offers_Pack_SessionsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Pack_SessionsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_pack_sessions(inputs)
	return en_offers_pack_sessions(inputs)
});